import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-desplegables',
  templateUrl: './desplegables.component.html',
  styleUrls: ['./desplegables.component.scss']
})
export class DesplegablesComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  utils: any;
  codeImport: string = `
  <script src="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.10/dist/js/bootstrap-select.min.js" type="text/javascript"></script>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.10/dist/css/bootstrap-select.min.css" rel="stylesheet" type="text/css" />`;
  highlighted: boolean = false;
  constructor(private highlightService: HighlightService) {

    this.arrayComponent = [
      {
        id: 'simple',
        titulo: 'Simple',
        subtitulo: 'Select simple, use el atributo <code>title</code> dentro de la etiqueta <code>select</code> para usar como marcador (placeholder)',
        codejs: `/* jquery */ 
$("select").selectpicker();`,
        claseContainer: 'col-6',
        componentRender: `
<div class="select-govco">
  <label for="selector-simple">Selector *</label>
  <select id="selector-simple" class="selectpicker form-control" title="Por ejemplo: Guillermo Pérez">
    <option value="1">Choose city</option>
    <option value="2">Foobar</option>
    <option value="3">Is great</option>
  </select>
</div>
`,
      },
      {
        id: 'error',
        titulo: 'Error',
        subtitulo: `Select <code>error</code>. Use la clase <code>select-govco--error</code> para resaltar el campo con el error,
         también informe detalladamente el error usando la clase <code>error-feedback</code>`,
        codejs: `/* jquery */ 
$("select").selectpicker();`,
        claseContainer: 'col-6',
        componentRender: `
<div class="select-govco--error">
    <label for="selector-normal">Selector *</label>
    <select id ="selector-normal" class="form-control selectpicker" title="Por ejemplo: Guillermo Pérez"  required>
        <option value="1">Choose city</option>
        <option value="2">Foobar</option>
        <option value="3">Is great</option>
    </select>
    <div class="error-feedback">
      Campo sin diligenciar
    </div>
</div>

`,
      }, {
        id: 'desactivado',
        titulo: 'Desactivado',
        subtitulo: `Select <code>desactivado</code>. Use la clase <code>select-govco--inactive</code> para desactivar el campo`,
        codejs: `/* jquery */ 
$("select").selectpicker();`,
        claseContainer: 'col-6',
        componentRender:
          `<div class="select-govco--inactive">
    <label for="selector-normal">Selector *</label>
    <select disabled id ="selector-normal" class="form-control selectpicker" title="Por ejemplo: Guillermo Pérez">
        <option value="1">Choose city</option>
        <option value="2">Foobar</option>
        <option value="3">Is great</option>
    </select>
</div>`,
      }
    ];

    this.infoComponent = {
      titulo: "Desplegables (Select)",
      descripcion: `Al hacer clic muestra un menú que contiene una lista de opciones.
       El menú debe permanecer abierto hasta que el usuario seleccione una opción 
       o haga clic sobre el ícono desplegar. Para separar los contenidos estos menús 
       cuentan con líneas horizontales que dividen los contenidos.`
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.utils = window.utils;
    this.utils.init();
    // this.componentRender = this.exampleInput.nativeElement.innerHTML;
    // this.exampleInput.nativeElement.innerHTML = ""; 
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
}

